import React from 'react';
import Gallery from '../Gallery/Gallery';
import Spinner from '../Spinner/Spinner';
import Doco from '../Doco/Doco';
import FeaturedSpace from '../FeaturedSpace/FeaturedSpace';

export default class DashBoard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      items: null,
      showFeatured: false,
      featuredLink: null
    };
  }

  componentWillMount(){
    fetch("https://jelf6b1p53.execute-api.ap-southeast-2.amazonaws.com/prod/get-spaces")
    .then(result=>result.json()).then(json => {
      this.setState({ items: json });
    });
  }

      
  handleSelectFeatured(e, link) {
    let show;
    this.showFeatured ? show=false : show=true;
    this.setState( {
        featuredLink: link,
        showFeatured: show,
    })
  } 

  createDash(){
    if(!this.state.items){
      return (
        <Spinner/>
    )
    }else{
      return (
        <div>
          { !this.state.showFeatured ? (
            <div className="container">
              <div className="row">
                <div className="col">
                <Gallery handler={this.handleSelectFeatured.bind(this)}/>
                <Doco/>
                </div>
              </div>
            </div>
        ) : <FeaturedSpace link={this.state.featuredLink}/> }
        </div>
      )
    }
  }

  render() {
    const { isAuthenticated } = this.props.auth;
    return(
      <div>
        {isAuthenticated() && (this.createDash())}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/DashBoard/DashBoard.js